import React from 'react';
import Fade from 'react-reveal/Fade';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-scroll';
import { nanoid } from 'nanoid';
import Title from '../Title/Title';
import useLocalize from '../../common/intl/useLocalize';
import useDevice from '../../common/device/useDevice';
import AboutImg from '../Image/AboutImg';
import { DEFAULT_DELAY, DEFAULT_DURATION } from '../../common/constants';

const About = () => {
  const { isDesktop, isMobile } = useDevice();

  const localize = useLocalize();

  const persons = React.useMemo(
    () => [
      {
        personId: nanoid(),
        image: 'Artsiom.webp',
        personName: localize('about-Artsiom-name'),
        text: localize('about-artsiom'),
        networks: [
          {
            id: nanoid(),
            name: 'linkedin',
            url: 'https://www.linkedin.com/in/artsiom-marozau/',
          },
          {
            id: nanoid(),
            name: 'github',
            url: 'https://github.com/MarozauArtsiom',
          },
        ],
      },
      {
        personId: nanoid(),
        image: 'Mikalai.webp',
        personName: localize('about-Mikalai-name'),
        text: localize('about-mikalai'),
        networks: [
          {
            id: nanoid(),
            name: 'github',
            url: 'https://github.com/DrJekill352',
          },
        ],
      },
      {
        personId: nanoid(),
        image: 'Dzianis.webp',
        text: localize('about-dzianis'),
        personName: localize('about-Dzianis-name'),
        networks: [
          {
            id: nanoid(),
            name: 'linkedin',
            url: 'https://www.linkedin.com/in/denis-levshukov-153a001b6/',
          },
        ],
      },
    ],
    [localize]
  );

  return (
    <section id="about">
      <Container>
        <Title title={localize('about-about')} />
        {persons.map(({ personId, image, text, networks, personName }) => (
          <Row key={personId} className="about-wrapper">
            <Col md={3} sm={12} className="about-wrapper__stack">
              <Fade bottom duration={DEFAULT_DURATION} delay={DEFAULT_DELAY} distance="30px">
                <div className="about-wrapper__image">
                  <AboutImg alt="profile picture" filename={image} />
                </div>
                <div className="social-links">
                  {networks.map((network) => {
                    const { id, name, url } = network;
                    return (
                      <a
                        key={id}
                        href={url}
                        rel="noopener noreferrer"
                        target="_blank"
                        aria-label={name}
                      >
                        <i className={`fa fa-${name || 'refresh'} fa-inverse`} />
                      </a>
                    );
                  })}
                </div>
              </Fade>
            </Col>
            <Col md={9} sm={12}>
              <Fade
                left={isDesktop}
                bottom={isMobile}
                duration={DEFAULT_DURATION}
                delay={DEFAULT_DELAY * 2}
                distance="30px"
              >
                <div className="about-wrapper__info">
                  <p className="about-wrapper__info-text about-wrapper__header-text">
                    {personName}
                  </p>
                  <p className="about-wrapper__info-text">{text}</p>
                </div>
              </Fade>
            </Col>
          </Row>
        ))}
        <span className="cta-btn cta-btn--resume">
          <Link to="projects" smooth duration={DEFAULT_DURATION}>
            {localize('about-resume')}
          </Link>
        </span>
      </Container>
    </section>
  );
};

export default About;
